export default {
	namespaced: true,
	state: {
		notifications: []
	},
	actions: {
		notifyError({ commit }, notify) {
			commit('setNotify', notify)
		}
	},
	mutations: {
		setNotify(state, notify) {
			state.notifications = [...state.notifications, notify]
		},
		clearNotify(state) {
			state.notifications = []
		}
	}
}
